import {vnTemplate} from "./vnTemplate";

declare var ko: any;

export class appTitle_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
             <!-- ko if: !isLinkDisabled() -->
                <!-- ko if: homeLinkMethod() == "href" -->
                    <a data-bind="attr: { href: url }"><span data-bind="text: title"></span></a>
                <!-- /ko -->
                <!-- ko if: homeLinkMethod() == "assign" -->
                    <a data-bind="event: { click: onHomeLinkClick }"><span data-bind="text: title"></span></a>
                <!-- /ko -->
             <!-- /ko -->
            `;
    }

    protected getTemplateName(): string{
        return "appTitle-template";
    }

    protected getMainElementType(): string{
        return "h1";
    }

    protected getMainElementClasses(): Array<string>{
        return ["site-logo"];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return {
            title: ko.observable("no title")
            ,isLinkDisabled: ko.observable(false)
            ,url: ko.observable("/")
            ,homeLinkMethod: ko.observable("href")
            ,onHomeLinkClick: function(data){ huit_neuf_this.onHomeLinkClick();}
        };
    }

    public setTitle(title: string){
        this.getTemplateViewModel().title(title);
    }

    public onHomeLinkClick(){
        window.location.assign(this.getTemplateViewModel().url());
    }

    public setHomeLinkMethod(homeLinkMethod){
        this.getTemplateViewModel().homeLinkMethod(homeLinkMethod);
    }

    public setIsLinkDisabled(isLinkDisabled: boolean){
        this.getTemplateViewModel().isLinkDisabled(isLinkDisabled);
    }

    public setUrl(url: string){
        this.getTemplateViewModel().url(url);
    }

}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/appTitle_template.ts